import { Component, OnInit } from '@angular/core';
import { SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css']
})
export class ManagementComponent implements OnInit {

  seoData: SeoSocialShareData = {
    title:  'Property Management',
    description: 'Nepal Property Services (NEPROSE) offers commercial and private clients in Birtamod, Jhapa a full suite of integrated multidisciplinary contracted services to ensure seamless operation of their new or existing facilities.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
  }

}
